import React, { useEffect, useState, useCallback } from 'react';
import { object, bool } from 'prop-types';
import { throttle } from 'lodash';
import ResourcesTab from '@fiverr-private/resources_tab';
import { Button } from '@fiverr-private/fit';
import { Container } from '@fiverr-private/layout_components';
import Nav from '../../lib/Nav';
import withContext from '../../lib/withContext';
import * as bigSearchBarOffset from '../../utils/bigSearchBarOffset';
import * as subCategoriesOffset from '../../utils/subCategoriesOffset';
import { GuestBecomeSellerLink } from '../../components/GuestLinks/GuestBecomeSellerLink';
import JoinLink from '../../components/JoinLink';
import Layout from '../../components/Layout';
import LeanLocaleSettingsLink from '../../components/LocaleSettingsLinks/LeanLocaleSettingsLink';
import LoginLink from '../../components/LoginLink';
import { Logo } from '../../components/Logo';
import MainRow from '../../components/MainRow';
import Navicon from '../../components/Navicon';
import SearchAnimated from '../../components/SearchAnimated';
import toggleCategoriesNavigation from '../../lib/toggleCategoriesNavigation';
import { BusinessProSolutionsNavigation } from '../../components/BusinessProSolutionsNavigation';

import './style.scss';
import './categoriesStyles.scss';
import { hidingXXL, showingXXL } from '../LoggedOut/index.ve.css';

export const LoggedOutHomepage = ({ rollouts, isEligibleForOnboardingExperience }) => {
    const [showSearch, setShowSearch] = useState(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleScroll = useCallback(
        throttle(() => {
            const scrollDistance = window.scrollY;
            const isTopOfPage = scrollDistance === 0;

            const shouldShowSearch = !isTopOfPage && bigSearchBarOffset.get() <= 0;
            const shouldShowCategories = !isTopOfPage && subCategoriesOffset.get() <= 0;

            setShowSearch(shouldShowSearch);
            toggleCategoriesNavigation(shouldShowCategories);
        }, 100),
        []
    );

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Trigger once on mount, to account for a pre-scrolled window

        return () => window.removeEventListener('scroll', handleScroll);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Layout className="logged-out-homepage-header">
            <MainRow>
                <Navicon />
                <Logo />
                <SearchAnimated show={showSearch} rollouts={rollouts} />
                <Nav alignToRight className="nav-with-space">
                    <Nav.Item className="nav-solution-button" displayFromMD>
                        <BusinessProSolutionsNavigation />
                    </Nav.Item>
                    <Nav.Item displayFromMD>
                        <ResourcesTab headerType="logged_out" rollouts={rollouts} />
                    </Nav.Item>
                    <Nav.Item displayFromLG>
                        <Container className={hidingXXL}>
                            <LeanLocaleSettingsLink shortenedLabel />
                        </Container>
                        <Container className={showingXXL}>
                            <LeanLocaleSettingsLink />
                        </Container>
                    </Nav.Item>
                    <Nav.Item displayFromMD>
                        <GuestBecomeSellerLink />
                    </Nav.Item>
                    <Nav.Item displayFromSM>
                        <LoginLink />
                    </Nav.Item>
                    <Nav.Item>
                        <JoinLink
                            inLynxesSeamlessOnboardingAndRoutingRollout={
                                rollouts?.inLynxesSeamlessOnboardingAndRoutingRollout
                            }
                            inLynxesSeamlessOnboardingMixpanelRecordingsRollout={
                                rollouts?.inLynxesSeamlessOnboardingMixpanelRecordingsRollout
                            }
                            isEligibleForOnboardingExperience={isEligibleForOnboardingExperience}
                            color={Button.COLORS.BLACK}
                        />
                    </Nav.Item>
                </Nav>
            </MainRow>
        </Layout>
    );
};

LoggedOutHomepage.propTypes = {
    rollouts: object,
    isEligibleForOnboardingExperience: bool,
};

LoggedOutHomepage.defaultProps = {
    rollouts: {},
};

/**
 * @param {HeaderProps} props
 * @returns {React.ReactElement} Header
 */
export default withContext(LoggedOutHomepage);
